var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 17.7083H5.83317C2.7915 17.7083 1.0415 15.9583 1.0415 12.9167V7.08332C1.0415 4.04166 2.7915 2.29166 5.83317 2.29166H14.1665C17.2082 2.29166 18.9582 4.04166 18.9582 7.08332V12.9167C18.9582 15.9583 17.2082 17.7083 14.1665 17.7083ZM5.83317 3.54166C3.44984 3.54166 2.2915 4.69999 2.2915 7.08332V12.9167C2.2915 15.3 3.44984 16.4583 5.83317 16.4583H14.1665C16.5498 16.4583 17.7082 15.3 17.7082 12.9167V7.08332C17.7082 4.69999 16.5498 3.54166 14.1665 3.54166H5.83317Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10.725C9.29998 10.725 8.59165 10.5083 8.04998 10.0666L5.44164 7.98331C5.17498 7.76664 5.12498 7.37497 5.34165 7.10831C5.55831 6.84164 5.94998 6.79164 6.21665 7.00831L8.82497 9.09164C9.45831 9.59998 10.5333 9.59998 11.1666 9.09164L13.775 7.00831C14.0416 6.79164 14.4416 6.83331 14.65 7.10831C14.8666 7.37497 14.825 7.77498 14.55 7.98331L11.9416 10.0666C11.4083 10.5083 10.7 10.725 9.99998 10.725Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.712e0d0bbb5f7ba6053a6e5bdbfa6d59.svg";
export { ForwardRef as ReactComponent };